import script from "./AppLayoutFloatingMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutFloatingMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutFloatingMenu.vue?vue&type=style&index=0&id=0c766d66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c766d66"]])

export default __exports__